const { DEV, VITE_LOCAL } = import.meta.env

import { postService as local } from './post.service.local'
import { postService as remote } from './post.service.remote'

function getEmptyPost() {
  return {
    title: '', // כותרת הכתבה
    description: '', // תיאור המאמר (מינימום 150 תווים)
    content: '', // תוכן המאמר (ב-HTML או Markdown)
    tags: [], // תגיות (למשל: ['חדשות', 'חוות דעת'])
    spoilerWarning: false, // אזהרת ספוילר
    isNew: true, // אם הכתבה חדשה באתר (לאחר שבוע משתנה ל-false)
    linkedAnime: '', // קישור לאנימה (לא חובה)
    imageUrl: '', // כתובת URL של התמונה
    likes: [], // מספר לייקים
    createdAt: '', // תאריך יצירה
    tableOfContents: [], // תוכן עניינים (למשל: ['מבוא', 'ניתוח', 'סיכום'])
    helpful: {
      yes: { count: 0, users: [] }, // רשימת משתמשים שסימנו 'כן'
      no: { count: 0, users: [] }, // רשימת משתמשים שסימנו 'לא'
    },
    author: {
      userId: '', // מזהה ייחודי של המשתמש
      nickname: '', // שם המשתמש
      userImage: '', // תמונת המשתמש
    },
  }
}

const service = VITE_LOCAL === 'true' ? local : remote
export const postService = { getEmptyPost, ...service }

if (DEV) window.postService = postService
